export default "__VITE_ASSET__Dl$7EVfu__"